import { memo } from 'react';
import { Card, CardMedia } from '@mui/material';
import { useObjectUrl } from 'hooks/useObjectUrl';

type ImagePreviewProps = {
  title: string;
  data: File | Blob;
  minHeight?: number;
};

const ImagePreviewComponent = (props: ImagePreviewProps): JSX.Element => {
  const { title, data, minHeight = 400 } = props;

  const objectUrl = useObjectUrl(data);

  return (
    <Card>
      <CardMedia
        sx={{
          minHeight,
          width: '100%',
          borderRadius: 2,
        }}
        image={objectUrl}
        title={title}
      />
    </Card>
  );
};

export const ImagePreview = memo(ImagePreviewComponent);
